import { faCheck } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, CircularProgress, Divider, Stack, Typography, useTheme } from '@mui/material'

type Props = {
	step: number
	title: string
	subtitle: string
	buttonLabel: string
	complete: boolean
	disabled?: boolean
	isLoading?: boolean
	onClick: () => void
}

export default function ActionTask({
	step,
	title,
	subtitle,
	buttonLabel,
	complete,
	disabled = false,
	isLoading = false,
	onClick,
}: Props) {
	const theme = useTheme()

	return (
		<Box data-testid={`action-task-${step}`} sx={{ width: '100%' }}>
			<Divider />
			<Stack direction="row" alignItems="flex-start" gap={2} py={2}>
				<Box
					sx={{
						width: 40,
						height: 40,
						borderRadius: '50%',
						backgroundColor: complete ? theme.palette.success.main : theme.palette.primary.main,
						color: '#fff',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexShrink: 0,
					}}
					data-testid={`action-task-${step}-complete=${complete}`}
				>
					{isLoading && <CircularProgress size={20} sx={{ color: '#fff' }} />}
					{!isLoading && complete && <FontAwesomeIcon icon={faCheck} size="lg" />}
					{!isLoading && !complete && (
						<Typography fontWeight={700} lineHeight={1}>
							{step}
						</Typography>
					)}
				</Box>
				<Stack gap={1.5}>
					<Box>
						<Typography
							fontWeight={700}
							color={complete ? theme.palette.text.disabled : theme.palette.text.primary}
							data-testid={`action-task-${step}-title`}
						>
							{title}
						</Typography>
						<Typography
							variant="body2"
							color={complete ? theme.palette.text.disabled : theme.palette.text.secondary}
							data-testid={`action-task-${step}-subtitle`}
						>
							{subtitle}
						</Typography>
					</Box>
					<Button
						variant="outlined"
						size="small"
						color={complete ? 'success' : 'primary'}
						disabled={disabled || isLoading}
						onClick={onClick}
						sx={{ alignSelf: 'flex-start', p: 1 }}
						data-testid={`action-task-${step}-button`}
					>
						{complete ? 'View' : buttonLabel}
					</Button>
				</Stack>
			</Stack>
			<Divider />
		</Box>
	)
}
